"use client";

import { TrashIcon } from "@heroicons/react/24/outline";
import { useState } from "react";

import { DeleteConversionMultiModal } from "@/app/modals/DeleteConversionMultiModal";
import { AudioPlayerDownloadConversion } from "@/components/audioPlayers/audioPlayerDownloadConversion/AudioPlayerDownloadConversion";
import { Button } from "@/components/buttons/Button";
import {
  ConversionConstructedNoDates,
  MixedModelConstructedNoDates,
  ModelNoDates,
  UserNoDates,
} from "@/types/types";

export function Details({
  conversionMulti,
  models,
  mixedModelsConstructed,
  user,
}: {
  conversionMulti: ConversionConstructedNoDates[];
  models: ModelNoDates[] | null;
  mixedModelsConstructed: MixedModelConstructedNoDates[] | null;
  user: UserNoDates;
}) {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const conversionMultiId = conversionMulti[0]?.conversionMultiId ?? null;
  const isConversionMultiDone = conversionMulti.every(
    (conversion) => conversion.confirmedDone || conversion.failed
  );

  return (
    <>
      <ul className="mt-6 flex flex-col gap-3">
        {conversionMulti.map((conversion) => (
          <AudioPlayerDownloadConversion
            key={conversion.id}
            conversion={conversion}
            models={models}
            user={user}
            mixedModelsConstructed={mixedModelsConstructed}
          />
        ))}
      </ul>
      {conversionMultiId !== null && isConversionMultiDone && (
        <>
          <div className="mt-4 flex justify-end">
            <Button
              variant="ghost"
              className="flex items-center gap-x-1 !p-0 text-xs"
              onClick={() => setIsDeleteModalOpen(true)}
            >
              Delete conversions
              <TrashIcon className="h-4 w-4" />
            </Button>
          </div>

          <DeleteConversionMultiModal
            open={isDeleteModalOpen}
            closeModal={() => setIsDeleteModalOpen(false)}
            conversionMultiId={conversionMultiId}
            conversionCount={conversionMulti.length}
          />
        </>
      )}
    </>
  );
}
